<template>
  <div class="carMonitorStatistics" :class="[styleType == 'typeGreen'?'carMonitorStatistics_green':styleType=='typeBlue'?'carMonitorStatistics_blue':'' ,isBaoSteel?'isBaoSteel':null, styleType == 'typeStrong' ? 'carMonitorStatistics_strong' : '']">
    <door-box :height="812" width="100%">
      <div class="box_wrap">
        <div class="left">
          <leftRecord @recordecheckclick="recordeCheckClick" @getLeftInfo="getLeftInfo"/>
        </div>
        <div class="right">
          <rightCount :asyncClick="asyncClick" :leftInfo="leftInfo"/>
        </div>
      </div>
    </door-box>
  </div>
</template>

<script>
import leftRecord from "./component/leftRecord";
import rightCount from "./component/rightCount";
import doorBox from "../components/doorBox";
export default {
  components: { doorBox, rightCount, leftRecord },
  name: "carMonitorStatistics",
  title: "运输车辆进出厂监控统计",
  props: {},
  data() {
    return {
      asyncClick: false,
      styleType: "",
      isBaoSteel: bmeConfig.isBaoSteel,
      leftInfo: {
        timeInfo: []
      }
    };
  },
  created() {
    this.styleType = this.$store.state.styleType;
  },
  computed: {
    curStyleTypeVal() {
      return this.$store.state.styleType;
    },
  },
  watch: {
    curStyleTypeVal: {
      handler(newVal, oldVal) {
        this.styleType = newVal;
      },
      deep: true,
    },
  },
  methods: {
    recordeCheckClick: function () {
      if (this.asyncClick) {
        this.asyncClick = false;
      } else {
        this.asyncClick = true;
      }
    },
    getLeftInfo: function(val) {
      this.leftInfo.timeInfo = val.timeInfo
    }
  },
};
</script>

<style lang="scss" scoped="scoped">
.carMonitorStatistics {
  padding: 20px;
  // border: 1px solid green;
  height: 100%;
  @include bg-box(100%, 100%, "leftBig.png");
  &.isBaoSteel {
    background: #020F3F;
  }
  .box_wrap {
    display: flex;
    height: 100%;
    .left {
      width: 49%;
    }
    .right {
      width: 51%;
    }
  }
}
.carMonitorStatistics_green {
  @include bg-box(100%, 100%, "leftBig_green.png");
}
.carMonitorStatistics_blue {
  background: rgba(0, 106, 255, 0.05);
  border: 1px solid rgba(132, 170, 255, 0.5);
}
.carMonitorStatistics_strong {
  @include bg-box(100%, 100%, "leftBig_strong.png");
}
</style>

<style lang="scss">
.carMonitorStatistics_blue {
  .el-table th.is-leaf,
  .el-table td {
    background: rgba(1, 18, 43, 0.81);
  }
}
</style>
